import React from "react";

const LABELS = { baru: "Baru", segera: "Segera", populer: "Populer" };

/**
 * Small status badge. "Baru" uses --status-pre-order and "Populer"
 * --status-ready (spec section 3); "Segera" is neutral grey, because it marks
 * something that is not there yet rather than something to look at.
 */
const Pill = ({ kind }) => (LABELS[kind] ? <span className={`hc-pill hc-pill--${kind}`}>{LABELS[kind]}</span> : null);

export default Pill;
